import { library } from '@fortawesome/fontawesome-svg-core';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Bar } from 'react-chartjs-2';
import { IAnnotationStatusStatisticsDto } from '../projectDetailsStatistics.model';

library.add(faChartBar);

interface IAnnotationProgressChartProps {
  annotationStatus?: IAnnotationStatusStatisticsDto;
  translateNames?: boolean;
}

export const AnnotationStatusChart = observer((props: IAnnotationProgressChartProps): ReactElement => {
  const { t } = useTranslator();
  const { annotationStatus, translateNames } = props;

  if (!annotationStatus) {
    return <></>;
  }

  const style = getComputedStyle(document.body);

  const segmentationData = {
    labels: [t('awaiting_review'), t('accepted'), t('rejected')],
    datasets: [
      {
        backgroundColor: style.getPropertyValue('--joy-palette-primary-500'),
        hoverBackgroundColor: style.getPropertyValue('--joy-palette-primary-500'),
        data: [annotationStatus.toReview, annotationStatus.accepted, annotationStatus.rejected],
      },
    ],
  };

  return (
    <div className='statistic-wrapper'>
      <div className='statistic-wrapper-header'>{translateNames ? t(annotationStatus.name) : annotationStatus.name}</div>
      <div className='statistics-body'>
        <div className='statistics-summary'>
          <div>
            {t('awaiting_review')}: {annotationStatus.toReview}
          </div>
          <div>
            {t('accepted')}: {annotationStatus.accepted}
          </div>
          <div>
            {t('rejected')}: {annotationStatus.rejected}
          </div>
        </div>
        <div className='chart-wrapper'>
          <div className='statistics-chart'>
            <Bar
              data={segmentationData}
              options={{
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false,
                  },
                  tooltip: {
                    mode: 'index',
                    intersect: false,
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                    suggestedMin: 0,
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
